import React, { useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import Headroom from "react-headroom";
import Header from "./components/Header/Header";
import { InnerRouter } from "./router/InnerRouter";
import { Footer } from "./components/Footer/Footer";
import { logout, setSiteState } from "./hookState/SiteState";
import Helper from "./utillity/helper";
import { useProfileState } from "./hookState/ProfileState";
import { Navbar } from "./components/Navbar/Navbar";
// import Cookies from "./components/Cookies/Cookies";
import { PlusJakartaSans_400Regular } from "@expo-google-fonts/plus-jakarta-sans/400Regular";
import { Raleway_400Regular } from "@expo-google-fonts/raleway/400Regular";
import { Raleway_300Light } from "@expo-google-fonts/raleway/300Light";

import TagManager from "react-gtm-module";
import { NewFooter } from "./components/NewFooter";
import { useHeaderState } from "./hookState/HeaderState";
const tagManagerArgs = {
	gtmId: "GTM-5NJJ4WDM",
};
TagManager.initialize(tagManagerArgs);
function App() {
	window.dataLayer.push({
		event: "pageview",
	});
	const profileState = useProfileState();
	const headerState = useHeaderState();
	let theme = createTheme({
		palette: {
			primary: {
				main: "#fff",
				// main: "#FF0000",
			},
			secondary: {
				// main:'#fff'
				// main: "#4165ae",
				main: "#0081FF",
			},
			tertiary: {
				main: "#FFAC1C",
			},
			common: {
				white: "#FFF",
			},
		},
		components: {
			MuiListItemIcon: {
				styleOverrides: {
					root: {
						minWidth: 30,
						color: "#fff",
					},
				},
			},
			MuiCardContent: {
				styleOverrides: {
					root: {
						padding: 0,
					},
				},
			},
			MuiListItemText: {
				styleOverrides: {
					primary: {
						color: "#000000",

						fontfamily: "Roboto, Helvetica, Arial, sans-serif",
						fontWeight: 400,
						fontSize: 14,
					},
				},
			},
			MuiToolbar: {
				styleOverrides: {
					root: {
						height: 70,
					},
				},
			},
			MuiSvgIcon: {
				styleOverrides: {
					root: {
						color: "primary.main",
					},
				},
			},
			MuiAvatar: {
				styleOverrides: {
					img: {
						objectFit: "contain",
					},
				},
			},

			MuiButton: {
				styleOverrides: {
					root: {
						borderRadius: "16px", // this needs to check using spacing
					},
				},
			},
			MuiTypography: {
				styleOverrides: {
					root: {
						// minWidth: 30,
						// fontFamily: "Plus Jakarta Sans",
						fontFamily: "Raleway_300Light",
					},
				},
			},
			MuiCssBaseline: {
				styleOverrides: {
					root: {
						// minWidth: 30,
						// color: "#fff",
						// fontFamily: [PlusJakartaSans_400Regular],
						fontFamily: [Raleway_300Light],
					},
				},
			},
			// typography: {
			// 	fontFamily: plusJakarta,
			// },
			overrides: {
				MuiCssBaseline: {
					"@global": {
						// "@font-face": PlusJakartaSans_400Regular,
						"@font-face": Raleway_300Light,
					},
				},
			},
			// MuiOutlinedInput: {
			// 	styleOverrides: {
			// 		root: {
			// 			borderRadius: "16px", // this needs to check using spacing
			// 		},
			// 	},
			// },
			MuiFormControl: {
				styleOverrides: {
					root: {
						margin: 2, // this nees to check using spacing
					},
				},
			},
		},
	});

	if (Helper.getStorage("userInfo")) {
		const userInfo = Helper.getStorage("userInfo");
		// console.log("userInfo in app", userInfo);
		setSiteState(userInfo);
	}
	useEffect(() => {
		setTimeout(() => {
			logout();
		}, 60 * 60 * 1000);
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<Box>
				<Router>
					{/* <CssBaseline />
					<Headroom>*/}
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							// m: "14px 20px",
							my: "14px",
							width: "100%",
						}}
					>
						<Header home={true} />
					</Box>
					{/* </Headroom> */}

					<Box sx={{ display: "flex", flexDirection: "row" }}>
						{/* <Box sx={{ zIndex: 99999 }}>
							<Cookies />
						</Box> */}

						<Box
							sx={{
								height: {
									xs: "100%",
									// md: "calc(100vh - 110px)"
									overflow: "scroll",
								},
								width: "100%",
							}}
						>
							<InnerRouter />
						</Box>
						<Box>
							{profileState.visible.get() && (
								<Box
									sx={{
										display: {
											xs: "none",
											md: "block",
										},
										// flexDirection: "row",
										// height: "calc(100vh - 110px)",
										overflow: "scroll",
									}}
								>
									<Navbar />
								</Box>
							)}
						</Box>
					</Box>
					<NewFooter />
				</Router>
			</Box>
		</ThemeProvider>
	);
}

export default App;
